import { has, toMoney } from "shared/utils";
import { IncomeActivity } from "../types";
import { Show } from "shared/components/helpers/Show";
import { getFullName } from "shared/utils/get-full-name";

export const CombinedIncomeOverrides = ({
  activityItem
}: {
  activityItem: IncomeActivity;
}) => {
  return (
    <div>
      <h2 className="text-base text-content-1000 mb-2">
        <span className="font-bold">
          {activityItem.activity_type === "verification_override"
            ? "Verified income for income source"
            : "Total verified income"}
        </span>{" "}
        was edited by {activityItem.author?.name || "Boom Admin"}
      </h2>
      <p className="text-sm text-content-400 border-b border-alpha-40 mb-4 pb-4">
        For{" "}
        {activityItem.details.contact.first_name
          ? getFullName({
              firstName: activityItem.details.contact.first_name,
              lastName: activityItem.details.contact.last_name,
              middleName: activityItem.details.contact.middle_name,
              short: true
            })
          : activityItem.details.contact.email || "applicant"}
        {/*  Ask vitaly to add Income source name */}
      </p>

      <ul className="space-y-2 list-disc pl-4 text-content-400 text-sm">
        <li>
          Gross monthly income: edited from{" "}
          <span className="font-medium">
            {toMoney(activityItem.details.original_income.gross_monthly_income)}
          </span>{" "}
          to{" "}
          <span className="font-medium">
            {toMoney(
              activityItem.details.overridden_income
                .overridden_gross_monthly_income
            )}
          </span>
        </li>
        <Show
          if={has(
            activityItem.details.overridden_income.overridden_net_monthly_income
          )}
        >
          <li>
            Net monthly income: edited from{" "}
            <span className="font-medium">
              {toMoney(activityItem.details.original_income.net_monthly_income)}
            </span>{" "}
            to{" "}
            <span className="font-medium">
              {toMoney(
                activityItem.details.overridden_income
                  .overridden_net_monthly_income
              )}
            </span>
          </li>
        </Show>
      </ul>
    </div>
  );
};
